export const preferencesFormatter = data =>
  data.reduce((acc, item) => {
    acc[item.type] = item.value;

    return acc;
  }, {});
